import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=0b87fa71&scoped=true&"
import script from "./CommunityCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCard.vue?vue&type=style&index=0&id=0b87fa71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87fa71",
  null
  
)

export default component.exports